var _a;
import { createActions } from 'redux-actions';
export var getPrimaryCategories = (_a = createActions('GET_PRIMARY_CATEGORIES', 'GET_PRIMARY_CATEGORIES_COMPLETE'), _a.getPrimaryCategories), getPrimaryCategoriesComplete = _a.getPrimaryCategoriesComplete;
